<template>
    <v-row class="px-2" style="border:solid 1px #e4e4e4;">
        <v-col cols="12" md="12" lg="12" sm="12">
            <v-simple-table dense>
                <template v-slot:default>
                    <tbody class="simple-table-body">
                        <tr>
                            <th id="studentName">Student Transfer</th>
                            <td>
                                <div class="student-td-div">
                                    <p>From</p>
                                    <p>{{financeTemplateDetails.studentTransferFrom}}</p>
                                </div>
                            </td>
                            <td>
                                <div class="student-td-div">
                                    <p>To</p>
                                    <p>{{financeTemplateDetails.studentTransferTo}}</p>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th id="studentName">Student Name</th>
                            <td class="pl-4" colspan="2">
                                {{ financeTemplateDetails.studentName }}
                            </td>
                        </tr>
                        <tr>
                            <th id="studentName">Enrollment Number</th>
                            <td class="pl-4" colspan="2">
                                {{ financeTemplateDetails.enrollmentCode }}
                            </td>
                        </tr>
                        <tr>
                            <th id="studentName">Class</th>
                            <td class="pl-4" colspan="2">
                                {{ financeTemplateDetails.class }}
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <v-divider class="my-4"/>
            <v-simple-table dense>
                <template v-slot:default>
                    <thead class="simple-table-header">
                        <th>Calculation For Internal Use</th>
                        <th>Calculation For Center</th>
                        <th>Calculation For Parent</th>
                    </thead>
                    <tbody class="simple-table-two-body">
                        <tr>
                            <th id="Particulars">Particulars</th>
                            <th id="centerHeader">
                                <div>
                                    <p>Exit Center</p>
                                    <p>New Center</p>
                                </div>
                            </th>
                            <th id="parentHeader">
                                <div>
                                    <p>Exit Center</p>
                                    <p>New Center</p>
                                </div>
                            </th>
                        </tr>
                        <tr>
                            <th id="nameOfCenter">Name of center</th>
                            <th id="centerName">
                                <div>
                                    <p>{{financeTemplateDetails.studentTransferFrom}}</p>
                                    <p>{{financeTemplateDetails.studentTransferTo}}</p>
                                </div>
                            </th>
                            <th id="parentCenterName">
                                <div>
                                    <p>{{financeTemplateDetails.studentTransferFrom}}</p>
                                    <p>{{financeTemplateDetails.studentTransferTo}}</p>
                                </div>
                            </th>
                        </tr>
                        <tr v-for="(item,index) in tableRowArray" :key="`customTableRow_${index}`">
                            <td>{{ item.lable }}</td>
                            <td>
                                <div>
                                    <p>{{ item.franchisee.old }}</p>
                                    <p>{{ item.franchisee.new }}</p>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <p>{{ item.parent.old }}</p>
                                    <p>{{ item.parent.new }}</p>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-col>
    </v-row>
</template>
<script>
export default {
  name: 'BranchTransferFinanceDetailsComponent',
  props: {
    finance: {
      type: Object,
      default: () => {}
    },
    exitDate: {
      type: String,
      default: null
    },
    newJoiningDate: {
      type: String,
      default: null
    },
    isOptional: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      oldCenterTuitionFee: 0,
      newCenterTuitionFee: 0,
      oldCenterParentTuitionFee: 0,
      newCenterParentTuitionFee: 0,
      tableRowArray: [],
      financeTemplateDetails: null
    }
  },
  watch: {
    finance: {
      handler (newVal) {
        this.financeTemplateDetails = newVal
        this.arrangeFinanceDetails()
      },
      deep: true,
      immediate: true
    },
    newJoiningDate () {
      this.arrangeFinanceDetails()
    }
  },
  created () {
    this.arrangeFinanceDetails()
  },
  methods: {
    arrangeFinanceDetails () {
      if (this.financeTemplateDetails && this.financeTemplateDetails.financeDetails) {
        this.financeTemplateDetails.financeDetails.forEach(item => {
          if (!this.isOptional) {
            if (item.fieldType === 'entryDate') {
              item.franchisee.new = this.newJoiningDate
              item.parent.new = this.newJoiningDate
            }
            if (item.fieldType === 'exitDate') {
              item.franchisee.old = this.exitDate
              item.parent.old = this.exitDate
            }
          }
        })
        this.tableRowArray = this.financeTemplateDetails.financeDetails
      }
    }
  }
}
</script>
<style>
.simple-table-header > th{
    background:#fff;
    border:1px solid #9e9e9e;
    height:30px;
    text-align:center!important;
}
.simple-table-two-body > tr:first-child > th, .simple-table-two-body > tr:nth-child(2) > th, .simple-table-two-body > tr > td{
    text-align:center!important;
    border:1px solid #9e9e9e;
    padding-left:0px!important;
    padding-right:0px!important;
}
.simple-table-two-body > tr:first-child > th > div, .simple-table-two-body > tr:nth-child(2) > th > div, .simple-table-two-body > tr > td > div{
    display: flex;
    flex-direction: row;
}
.simple-table-two-body > tr:first-child > th > div > p, .simple-table-two-body > tr:nth-child(2) > th > div > p,.simple-table-two-body > tr > td > div > p{
    display: flex;
    width:50%;
    align-items: center;
    justify-content: center;
    margin-bottom: 0px;
    height:31px;
}
.simple-table-two-body > tr:first-child > th > div > p:first-child, .simple-table-two-body > tr:nth-child(2) > th > div > p:first-child, .simple-table-two-body > tr > td > div > p:first-child{
    border-right:1px solid #9e9e9e;;
}
.simple-table-two-body > tr:first-child > th > div > p:last-child, .simple-table-two-body > tr:nth-child(2) > th > div > p:last-child, .simple-table-two-body > tr > td > div > p:last-child{
    border-left:1px solid #9e9e9e;;
}
.simple-table-body > tr > th{
    border:1px solid #9e9e9e;
}
.simple-table-body > tr > td{
    padding-left:0px!important;
    padding-right:0px!important;
}
.student-td-div{
    height:31px;
    display:flex;
    flex-direction: row;
}
.student-td-div > p{
    width:50%;
    display:flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-bottom:0px;
}
.student-td-div > p{
    padding-left:16px;
}
.student-td-div > p:last-child{
    background:#eeeeee;
}
</style>
